import moment from 'moment'
import * as tz from 'moment-timezone'

// working between dates and moments
// https://stackoverflow.com/questions/38384263/how-to-get-date-object-from-moment-js-after-formatting-it

const SERVER_TIMEZONE = 'UTC'
const SERVER_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'


/**
 * @param {Date/Moment/String} serverDate - expects a date of sorts
 * moment object
 * date object
 * 'YYYY-MM-DD HH:mm:ss' string that our server stores (assumed to be a server date)
 * @return {Moment} - because of timezones, it's necessary to return the whole object
 */
export function convertDateToUserLocal(serverDate: string|tz.Moment, opts: { barDisplay?: boolean} = {}): string {

  if (!serverDate) {
    console.warn('attempting to convert a date but none given')
    return null
  }
  if (typeof serverDate === 'string') {
    serverDate = tz.tz(serverDate, SERVER_TIMEZONE)
  }
  if (!moment.isMoment(serverDate)) {
    serverDate = moment(serverDate)
  }

  const userTZ = tz.tz.guess()
  const userDate = serverDate.tz(userTZ)

  // barDisplay is, for example, in DE: "31.07.2017 | 15:00"
  if (opts.barDisplay) {
    return `${userDate.format('L')} | ${userDate.format('LT')}`
  }
  return userDate.format('YYYY-MM-DD HH:mm:ss')

}

/**
 * @param {Date/Moment/String} serverDate - expects a date of sorts
 * moment object
 * date object
 * 'YYYY-MM-DD HH:mm:ss' string that our server stores (assumed to be a user date)
 * @param {Object} opts
 * @param {Bool} opts.simplified - returns in format for server
 * @return {Moment} - because of timezones, it's necessary to return the whole object
 */
export function convertDateToSystemLocal(
  localDate: string|tz.Moment,
  opts: { simplified?: boolean} = {}
): string|tz.Moment {

  if (!localDate) {
    console.warn('attempting to convert a date but none given')
    return null
  }
  if (typeof localDate === 'string') {
    // use userTZ if strings are allowed to come in as user time
    // use SERVER_TIMEZONE if all strings are assumed server strings
    const userTZ = tz.tz.guess()
    localDate = tz.tz(localDate, userTZ)
  }
  if (!moment.isMoment(localDate)) {
    localDate = moment(localDate)
  }
  const serverDate = localDate.tz(SERVER_TIMEZONE)
  
  if (opts.simplified) {
    return serverDate.format(SERVER_TIME_FORMAT)
  }
  return serverDate
}

